import * as React from "react";

import { FlagStore } from "../flux/Flag";
import { ErrorStore } from "../flux/Error";
import { SettingsStore } from "../components/Settings/SettingsStore";
import { InitSettingsCommand } from "../components/Settings/commands/InitSettingsCommand";
import { SaveSettingsCommand } from "../components/Settings/commands/SaveSettingsCommand";
import { ShowSettingsCommand } from "../components/Settings/commands/ShowSettingsCommand";

import { getLanguageOptions } from "../../polyglot/languagePacks";
import { Polyglot } from "../../polyglot";
import { LanguagePack } from "../../../translations";
import { GetSettingsFn, SaveSettingsFn } from "../../rest/settings";
import { Division } from "../../models";
import { Settings } from "../components/Settings/Settings";
import { CurrentDivisionStore } from "../components/DivisionPath/flux/CurrentDivisionStore";
import { Command } from "../../Command";

// This class is a configuration for Settings
// Constructor receives and/or creates dependencies and injects them
export class SettingsTab
{
    private readonly settingsSaveInProgressStore = new FlagStore();
    private readonly settingsErrorStore = new ErrorStore();
    private readonly settingsStore = new SettingsStore();

    readonly markup: JSX.Element;
    readonly settingsShowCommand: Command;
    
    constructor(polyglot: Polyglot, languagePacks: Map<string, LanguagePack>, getSettings: GetSettingsFn, saveSettings: SaveSettingsFn, currentDivisionStore: CurrentDivisionStore,  getCurrentDivision: () => Division, getCurrentDivisionId: () => number, render: () => void, isEmailNotificationEnabled: boolean, isAdmin: boolean)
    {
        const getCurrentLanguageOption = () => getLanguageOptions().find(opt => opt.code === polyglot.locale());
        const settingsInitCommand = new InitSettingsCommand(getSettings, getCurrentDivision, getLanguageOptions, getCurrentLanguageOption, this.settingsSaveInProgressStore.dispatchToken, this.settingsErrorStore.dispatchToken);
        const settingsSaveCommand = new SaveSettingsCommand(polyglot, languagePacks, render, saveSettings, getCurrentDivisionId, this.settingsStore, this.settingsSaveInProgressStore.dispatchToken, this.settingsErrorStore.dispatchToken);
        this.settingsShowCommand = new ShowSettingsCommand(this.settingsErrorStore.dispatchToken);

        this.markup = (
            <Settings
                polyglot={polyglot}
                currentDivisionStore={currentDivisionStore}
                initSettingsCommand={settingsInitCommand}
                settingsStore={this.settingsStore} saveSettingsCommand={settingsSaveCommand}
                inProgressStore={this.settingsSaveInProgressStore}
                errorStore={this.settingsErrorStore}
                isEmailNotificationEnabled={isEmailNotificationEnabled}
                isAdmin={isAdmin}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/init/settings.tsx